import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { addDays, format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import RosterApi from '../../../axios/Roster/RosterApi';
import CustomInput from '../../../components/CustomInput';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useLoading } from '../../../context/LoadingContext';
import { useSettings } from '../../../context/SettingsContext';
import CustomAutocomplete from '../../../components/CustomAutocomplete';
import CustomSelect from '../../../components/CustomSelect';
import DeviceApi from '../../../axios/Device/DeviceApi';
import SaveIcon from '@mui/icons-material/Save';

const RegistersDeviceDialog = ({ open, handleClose, handleRefreshTable, selectedUserGroup }) => {
   // const { open, handleClose, onRefresh, allUser, onChangeAllUser, status} = props;
   const [show, hide] = useLoading();
   const { t } = useTranslation();
   const { addDevice } = DeviceApi()


   const initialFormData = {
      ip: '',
      brand: '',
      port: '',
      deviceSn: '',
      deviceAttribute: '',
      description: '',
      group: selectedUserGroup?.id,
      langId: localStorage.getItem("i18nextLngId")

   };


   const [formData, setFormData] = useState(initialFormData);
   const [errors, setErrors] = useState({ port: '' });





   const handleCloseDialog = () => {
      setFormData(initialFormData);

      handleClose();
      setErrors(prev => ({ ...prev, port: '' }));
   };

   // const handleDataChange = (name, newData) => {
   //    setFormData((prevData) => ({
   //       ...prevData,
   //       [name]: newData,
   //    }));
   // };
   // const handleInputChange = (e) => {
   //    const { name, value } = e.target;
   //    setFormData((prevData) => ({
   //       ...prevData,
   //       [name]: value,
   //    }));
   // };

   // const [formData, setFormData] = useState({ port: '' });


   const handleInputChange = (e) => {
      const { name, value } = e.target;

      if (name === 'port') {
         if (/^\d*$/.test(value)) {
            setFormData(prev => ({ ...prev, [name]: value }));
            setErrors(prev => ({ ...prev, port: '' }));
         } else {
            setErrors(prev => ({ ...prev, port: t('common.valid-number') }));
         }
      } else {
         setFormData(prev => ({ ...prev, [name]: value }));
      }
   };





   const handleSubmit = async (e) => {

      try {
         const response = await addDevice(formData);
         if (response.data.responseCode === 0) {
            toast.success(t('common.registers-device-successfully'));
            handleCloseDialog()
            handleRefreshTable()
         } else {
            toast.error(response.data.message)
         }

      } catch (error) {
         if (error.response) {
            if (error.response.status !== 401) {
               toast.error(t(error?.response.data));
            }
         } else {
            toast.error(t('common.network-timeout'));
         }
         handleCloseDialog()
         // toast.error(error.response.data.message)

      }
   };

   return (

      <CustomDialog open={open} transitionDuration={300} maxWidth={'xl'} onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.registers-device')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            {/* <p className='pt-5 text-sm text-[#DC2626]'>{t('common.required-fields-are-marked-in-red')} "*".</p> */}
            <div className='grid grid-cols-12 md:gap-x-10 gap-y-10'>
               {/* <div className='col-span-12 md:col-span-6'>
                  <label>{t('common.shift')}</label><span className='text-[#EF4444] ml-1'>*</span>
                  <CustomSelect
                     name='shift'
                     value={formData.shift}
                     onChange={handleInputChange}
                     options={shiftsData}
                     className='mt-2'
                     dataType='shift'
                  />
               </div> */}
               {/* <div className='col-span-12 md:col-span-6 mt-6 space-y-[8px]'>
                  <label className='mb-2.5'>
                     {t('common.company-name')}<span className='text-[#EF4444] ml-1'>*</span>
                  </label>
                  <CustomSelect
                     name='shift'
                     value={formData.shift}
                     onChange={handleInputChange}
                     options={shiftsData}
                     dataType='shift'
                  />
               </div> */}
               {/* <div className='col-span-12 md:col-span-6 mt-6 space-y-[8px]'> */}
               {/* <label className='mb-2.5'>
                     {t('common.user-name')}
                  </label>
                  <CustomAutocomplete
                     name='userId'
                     options={usersData}
                     freeSolo={true}
                     // placeholder='Type to search user'
                     dataType='user'
                     onDataChange={handleDataChange}
                     value={formData.userId}
                  /> */}
               {/* <CustomAutocomplete
                     // className='min-w-60'
                     name='userName'
                     // value={formData.userName}
                     onDataChange={handleDataChange}
                     // value={usersData.find(user => user.employeeCode === formData.userName) || null}
                     options={usersData}
                     dataType='user'
                     freeSolo={true}
                     placeholder={t('common.content-161')}

                  /> */}
               {/* </div> */}


               <div className='col-span-12 md:col-span-6 mt-6 space-y-[8px]'>
                  <label className='block text-sm mb-2'>IP</label>
                  <CustomInput
                     name='ip'
                     inputType='text'
                     value={formData.ip}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder='IP'
                  />
               </div>
               <div className='col-span-12 md:col-span-6 mt-6 space-y-[8px]'>
                  <label className='block text-sm mb-2'>{t('common.brand')}</label>
                  <CustomInput
                     name='brand'
                     inputType='text'
                     value={formData.brand}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.brand')}
                  />
               </div>
               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.port')}<span className='text-[#EF4444] ml-1'>*</span></label>
                  <CustomInput
                     name='port'
                     inputType='text'
                     value={formData.port}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.port')}
                  />
                  {errors.port && (
                     <p className="text-red-500 text-xs mt-1">{errors.port}</p>
                  )}
               </div>
               {/* <div className='col-span-12 md:col-span-6'>
                  <label>{t('common.port')}</label>
                  <CustomInput
                     name='port'
                     inputType='text'
                     value={formData.port}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.port')}
                  />
               </div> */}
               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.device-sn')}<span className='text-[#EF4444] ml-1'>*</span></label>
                  <CustomInput
                     name='deviceSn'
                     inputType='text'
                     value={formData.deviceSn}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.device-sn')}
                  />
               </div>
               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.device-attribute')}</label>
                  <CustomInput
                     name='deviceAttribute'
                     inputType='text'
                     value={formData.deviceAttribute}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.device-attribute')}
                  />
               </div>
               <div className='col-span-12 md:col-span-6'>
                  <label className='block text-sm mb-2'>{t('common.description')}</label>
                  <CustomInput
                     name='description'
                     inputType='text'
                     value={formData.description}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     placeholder={t('common.description')}
                  />
               </div>
            </div>
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                  <CloseIcon />
                  <p>{t('button.cancel')}</p>
               </ControlpanelSecondaryButton>
               <ControlpanelPrimaryButton onClick={handleSubmit} disabled={!formData.deviceSn || !formData.port}>
                  <SaveIcon />
                  <p>{t('button.save')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>

   );
};

export default RegistersDeviceDialog;
